var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{attrs:{"id":"editor"}},[_c('froala',{ref:"editor",attrs:{"name":_vm.tempName,"tag":"textarea","config":_vm.froalaConfig},model:{value:(_vm.tempDescription),callback:function ($$v) {_vm.tempDescription=$$v},expression:"tempDescription"}})],1)])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68ad4f31","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/projects/ProjectDescription.vue
// module id = rWBd
// module chunks = 0